module.exports = __webpack_public_path__ + "img/step2_1.26564533.png";